import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Grid,
  Chip
} from '@mui/material';
import { Groups, Send, Chat, SmartToy } from '@mui/icons-material';

const StatItem = ({ icon, label, value, color = 'default' }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, p: 1.5, borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
    <Box sx={{ color }}>
      {icon}
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography variant="h4">{value}</Typography>
    </Box>
  </Box>
);

const CampaignStatsDialog = ({ open, onClose, selectedCampaign, stats, loading }) => {
  const periodText = stats?.period ? `${new Date(stats.period.start).toLocaleString()} — ${new Date(stats.period.end).toLocaleString()}` : '';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Campaign statistics
      </DialogTitle>
      <DialogContent dividers>
        {selectedCampaign && (
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" noWrap>{selectedCampaign.name}</Typography>
            {selectedCampaign.status && (
              <Chip size="small" label={selectedCampaign.status} />
            )}
          </Box>
        )}
        {periodText && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Period: {periodText}
          </Typography>
        )}
        {loading ? (
          <Typography variant="body2">Loading...</Typography>
        ) : (
          <Grid
              container
              spacing={2}
          >
            <Grid item xs={12} sm={6}>
              <StatItem icon={<Groups />} label="Contacts in campaign" value={stats?.contacts_total ?? 0} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <StatItem icon={<Send />} label="Sent (successful)" value={stats?.sent_success ?? 0} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <StatItem icon={<Chat />} label="Active dialogs" value={stats?.active_dialogs ?? 0} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <StatItem icon={<SmartToy />} label="AI-generated messages" value={stats?.ai_messages ?? 0} />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CampaignStatsDialog;
